import React from 'react';
import classnames from 'classnames';
import './SeparatorWithGradient.scss';

const SeparatorWithGradient = ({...props}) => (
  <div className={classnames("separator-with-gradient", props.className)}></div>
);

export default SeparatorWithGradient;
